/**
 * Serviço de auditoria de ações de autenticação
 */

import { supabase } from '@/integrations/supabase/client';

/**
 * Registra login de usuário na auditoria
 */
export const logUserLogin = async (
  userId: string,
  networkId: string | null,
  metadata?: Record<string, any>
): Promise<void> => {
  try {
    const userAgent = navigator?.userAgent || 'Unknown';
    
    const { error } = await supabase
      .from('audit_logs')
      .insert([{
        user_id: userId,
        network_id: networkId || userId, // Usar userId como fallback se não tiver network
        store_id: null,
        action: 'USER_LOGIN',
        entity: 'USER',
        entity_id: userId,
        user_agent: userAgent,
        result: 'SUCCESS',
        metadata: {
          ...metadata,
          userAgent,
          timestamp: new Date().toISOString(),
        },
      }]);

    if (error) {
      console.error('Erro ao registrar auditoria de login:', error);
    }
  } catch (error) {
    console.error('Erro ao criar log de auditoria de login:', error);
  }
};

/**
 * Registra logout de usuário na auditoria
 */
export const logUserLogout = async (
  userId: string,
  networkId: string | null
): Promise<void> => {
  try {
    const userAgent = navigator?.userAgent || 'Unknown';
    
    const { error } = await supabase
      .from('audit_logs')
      .insert([{
        user_id: userId,
        network_id: networkId || userId, // Usar userId como fallback se não tiver network
        store_id: null,
        action: 'USER_LOGOUT',
        entity: 'USER',
        entity_id: userId,
        user_agent: userAgent,
        result: 'SUCCESS',
        metadata: {
          userAgent,
          timestamp: new Date().toISOString(),
        },
      }]);

    if (error) {
      console.error('Erro ao registrar auditoria de logout:', error);
    }
  } catch (error) {
    console.error('Erro ao criar log de auditoria de logout:', error);
  }
};

/**
 * Registra reset de senha na auditoria
 */
export const logPasswordReset = async (
  userId: string,
  networkId: string | null,
  email: string
): Promise<void> => {
  try {
    const userAgent = navigator?.userAgent || 'Unknown';
    
    const { error } = await supabase
      .from('audit_logs')
      .insert([{
        user_id: userId,
        network_id: networkId || userId,
        store_id: null,
        action: 'PASSWORD_RESET',
        entity: 'USER',
        entity_id: userId,
        user_agent: userAgent,
        result: 'SUCCESS',
        metadata: {
          email,
          userAgent,
          timestamp: new Date().toISOString(),
        },
      }]);

    if (error) {
      console.error('Erro ao registrar auditoria de reset de senha:', error);
    }
  } catch (error) {
    console.error('Erro ao criar log de auditoria de reset de senha:', error);
  }
};
